import moment from 'moment';
import { Form } from 'dash-ui';
import { useTranslation } from 'react-i18next';

import { IYearBuildRangeInput } from './YearBuildRangeInput.interfaces';
import { DatePickerWrapper } from './YearBuildRangeInput.styles';

const YearBuildRangeInput = ({
  startYear,
  endYear,
  setYearRange,
}: IYearBuildRangeInput) => {
  const { t } = useTranslation('pages');
  const startYearAsDate = startYear ? moment([startYear, 1, 1]).toDate() : null;
  const endYearAsDate = endYear ? moment([endYear, 1, 1]).toDate() : null;

  return (
    <Form.Group mb={5} w="100%">
      <Form.Label md>{t('propertyPage.yearBuilt')}</Form.Label>
      <DatePickerWrapper>
        <Form.DateRangePicker
          showYearPicker
          dateFormat="yyyy"
          onChange={({ startDate, endDate }) => {
            setYearRange({
              startYear: startDate.getFullYear(),
              endYear: endDate.getFullYear(),
            });
          }}
          onClear={() => setYearRange({})}
          startDate={startYearAsDate}
          endDate={endYearAsDate}
          placeholderText="yyyy - yyyy"
        />
      </DatePickerWrapper>
    </Form.Group>
  );
};

export default YearBuildRangeInput;
